import styled, { css } from 'styled-components';
import { lighten, darken, rem } from 'polished';

const ColorTooltipSelectionActionButton = styled.button.attrs(() => ({
    type: 'button',
}))`
    background-color: transparent;
    border: 0;
    color: ${({ theme, skin }) => theme.button[skin].background};
    font-weight: 400;
    padding-bottom: ${({ theme }) => rem(theme.button.padding.sm.v)};
    padding-top: ${({ theme }) => rem(theme.button.padding.sm.v)};
    text-transform: inherit;

    &:hover {
        color: ${({ theme, skin }) => lighten(0.05, theme.button[skin].background)};
    }

    &:focus,
    &:active {
        color: ${({ theme, skin }) => darken(0.05, theme.button[skin].background)};
    }

    &,
    &:hover,
    &:focus,
    &:active {
        outline: 0;
        text-decoration: none;
    }

    ${({ disabled }) =>
        disabled &&
        css`
            cursor: not-allowed;
            opacity: 0.35;
            pointer-events: none;
        `}
`;

export default ColorTooltipSelectionActionButton;
